import PropTypes from "prop-types"
import { List, ListItemButton, ListItemText } from "@mui/material"
import { map, size } from "lodash"
import { SubcategoryShape } from "./helpers/prop-types"
import Metric from "./metric-item"
import CheckboxElement from "./checkbox"
import ExpandIcon from "./expand-icon"

export default function MetricsSubcategory({
  subcategory,
  disableOptions,
  toggleSection,
  toggleSelectedMetricColumn,
  includeMetricTypes,
  metricsSearchValue,
  getIsSectionOpen,
  getIsSelected,
  onMetricToggled,
}) {
  const { type, id, items, itemsSelected, totalItems, singleFactor, label, selector } = subcategory || {}
  const showCategoryItems = size(items) > 0
  const shouldShowCategory = showCategoryItems || singleFactor

  if (!shouldShowCategory) {
    return null
  }

  const isSectionOpen = getIsSectionOpen(selector)
  const isSelected = subcategory.singleFactor && getIsSelected(selector)
  const isDisabled = !isSelected && !showCategoryItems && disableOptions

  const itemCountLabel = metricsSearchValue
    ? ` (${size(items)} found)`
    : ` (${itemsSelected}/${totalItems})`

  function handleClick() {
    const handler = showCategoryItems ? toggleSection : toggleSelectedMetricColumn
    handler(subcategory.selector)
  }

  return <List disablePadding className="metrics-subcategory">
    <ListItemButton
      disabled={isDisabled}
      classes={{ root: "list-item" }}
      onClick={handleClick}
    >
      <CheckboxElement
        isHidden={showCategoryItems}
        isChecked={isSelected}
        isDisabled={isDisabled}
        className="metrics-checkbox"
      />
      <ListItemText>
        {label}
        {!singleFactor && <span className="items-count">{itemCountLabel}</span>}
      </ListItemText>
      <ExpandIcon
        isOpen={isSectionOpen}
        isHidden={!showCategoryItems}
      />
    </ListItemButton>

    {showCategoryItems && isSectionOpen && <List className="searchable-list" disablePadding>
      {map(items, item => <Metric
        key={`${type}.${item.id}`}
        subcategoryType={subcategory.type}
        subcategoryId={id}
        item={item}
        toggleSection={toggleSection}
        toggleSelectedMetricColumn={toggleSelectedMetricColumn}
        disableOptions={disableOptions}
        includeMetricTypes={includeMetricTypes}
        metricsSearchValue={metricsSearchValue}
        getIsSectionOpen={getIsSectionOpen}
        getIsSelected={getIsSelected}
        onMetricToggled={onMetricToggled}
      />)}
    </List>}
  </List>
}

MetricsSubcategory.propTypes = {
  subcategory: SubcategoryShape.isRequired,
  toggleSection: PropTypes.func.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  includeMetricTypes: PropTypes.bool,
  metricsSearchValue: PropTypes.string.isRequired,
  getIsSectionOpen: PropTypes.func.isRequired,
  getIsSelected: PropTypes.func.isRequired,
  onMetricToggled: PropTypes.func,
}
